import {Navigate, useParams} from "react-router-dom";
import {AccountShell, type AccountTabId} from "@/components/shop/AccountShell";
import {accountTabFromUrl, paths} from "@/lib/paths";

export function AccountTabPage() {
  const {tab} = useParams<{tab?: string}>();
  const internal = accountTabFromUrl(tab || "");
  if(internal === null) return <Navigate to={paths.account} replace />;
  return <AccountShell tab={internal as AccountTabId} />;
}
